import axios from "axios"
import { customToast } from "../components/toast/custom-react-toastify/v1"

const MAIN_API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function ProductOptionsApi(props) {
    return {
        searchListByOptionCodes: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/product-options/search/by-optionCodes`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        searchListDetail: async ({ params, headers, body }) => {
            return await axios.get(`${MAIN_API_HOST}/product-options/detail`, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        searchListByPackageOptionIds: async ({ params, headers, body }) => {
            return await axios.post(`${MAIN_API_HOST}/product-options/search/by-packageOptionIds`, body, {
                params,
                headers
            })
                .then(res => {
                    if (res.status === 200) {
                        return {
                            res: res,
                            content: res.data?.content
                        }
                    }
                })
                .catch(err => {
                    if (!err) {
                        customToast.error('서버와의 연결이 원할하지 않습니다.');
                        return;
                    }

                    let res = err.response;

                    customToast.error(res?.data?.message);
                })
        },
        searchRelatedProductOptionProjections: async ({params, headers, body}) =>{
            return await axios.get(`${MAIN_API_HOST}/product-options/${params.productOptionId}/related-items`, {
                params,
                headers
            });
        },
        searchProductOptionProjectionsByKeywords: async ({params, headers, body}) =>{
            return await axios.get(`${MAIN_API_HOST}/product-options/by-keywords`, {
                params,
                headers
            });
        }
    }
}